import type { Appointments } from "@/lib/appointments"
import { type Model, Modelling } from "@/lib/models"

export namespace Businesses {
  export type BusinessResult = {
    id: string
    type: `business`
    attributes: {
      address_1: string | null
      address_2: string | null
      city: string
      country: string
      description: string
      name: string
      post_code: string
      state: string | null
      phone: string | null
      email: string | null
      website_address: string | null
      active_tease: boolean | null
    }
    relationships: {
      available_appointments: {
        data: Appointments.AppointmentResult[]
      }
    }
  }

  export type Business = BusinessResult

  export const BusinessModel: Model<`Business`> = () => {
    return {
      id: `string`,
      type: Modelling.equality(`item`, `business`),
      attributes: {
        address_1: [`string`, null],
        address_2: [`string`, null],
        city: `string`,
        country: `string`,
        description: `string`,
        name: `string`,
        post_code: `string`,
        state: [`string`, null],
        phone: [`string`, null],
        email: [`string`, null],
        website_address: [`string`, null],
        active_tease: [`boolean`, null],
      },
      relationships: {
        available_appointments: {
          data: Modelling.reference(`array`, `AppointmentResult`),
        },
      },
    }
  }
}
